function saveCurrentPage(){
	var lbPageIsValid;
	var loForm = document.frmMG;
	var lbSave;

	lbSave = true;
	if(window.bDoNotSaveOnNavigateTo) {
		if(window.bDoNotSaveOnNavigateTo == true) {
			lbSave = false;
		}
	}
	lbPageIsValid = true;
	if (window.fpValidateData) {
		lbPageIsValid = window.fpValidateData();
	}

	if (lbPageIsValid == true) {
		loForm.bStorePage.value = lbSave;
		loForm.sDestPage.value = loForm.sSrcPage.value;
		submit_form(loForm);
	}
	return;
}

function refreshCurrentPage(){
var loForm = document.frmMG;

	loForm.bStorePage.value = false;
	loForm.sDestPage.value = loForm.sSrcPage.value;
	submit_form(loForm);
	
	return;
}

function toggleInteractiveMode(psInteractiveModeSwitch){
	var loForm = document.frmMG;
	var lbSave;

	lbSave = true;
	if(window.bDoNotSaveOnNavigateTo) {
		if(window.bDoNotSaveOnNavigateTo == true) {
			lbSave = false;
		}
	}
	lbContinue = true;
	if (window.fpValidateData) {
		lbContinue = window.fpValidateData();
	}

	if (lbContinue) {	
		loForm.bStorePage.value = lbSave;
		loForm.bToggleInteractiveMode.value = true;
		loForm.sDestPage.value = loForm.sSrcPage.value;
		submit_form(loForm);
	}
	return;
}

function launchToolbarClientsAndAdministration() {
var lbContinue;
var loForm = document.frmMG;
var lbSave;

	lbSave = true;
	if(window.bDoNotSaveOnNavigateTo) {
		if(window.bDoNotSaveOnNavigateTo == true) {
			lbSave = false;
		}
	}

	lbContinue = true;
	if (window.fpValidateData) {
		lbContinue = window.fpValidateData();
	}
	if (lbContinue) {
		loForm.sModuleToLoad.value = '../clients/clients.asp';
		loForm.bSaveUserData.value = lbSave;
		submit_form(loForm);
	}
	return lbContinue;	
}

function launchToolbarPlanningMenu() {
var lbContinue;
var loForm = document.frmMG;
var lbSave;

	lbSave = true;
	if(window.bDoNotSaveOnNavigateTo) {
		if(window.bDoNotSaveOnNavigateTo == true) {
			lbSave = false;
		}
	}
	lbContinue = true;
	if (window.fpValidateData) {
		lbContinue = window.fpValidateData();
	}
	if (lbContinue) {
		loForm.sModuleToLoad.value = '../plans/plans.asp';
		loForm.bSaveUserData.value = lbSave;
		submit_form(loForm);
	}
	return lbContinue;	
}

function launchToolbarMyPlans() {
var lbContinue;
var loForm = document.frmMG;
var lbSave;

	lbSave = true;
	if(window.bDoNotSaveOnNavigateTo) {
		if(window.bDoNotSaveOnNavigateTo == true) {
			lbSave = false;
		}
	}
	lbContinue = true;
	if (window.fpValidateData) {
		lbContinue = window.fpValidateData();
	}
	if (lbContinue) {
		loForm.sModuleToLoad.value = '../plans/plans.asp';
		loForm.bSaveUserData.value = lbSave;
		submit_form(loForm);
	}
	return lbContinue;	
}

function launchToolbarCalculators() {
var lbContinue;
var loForm = document.frmMG;
var lbSave;

	lbSave = true;
	if(window.bDoNotSaveOnNavigateTo) {
		if(window.bDoNotSaveOnNavigateTo == true) {
			lbSave = false;
		}
	}
	lbContinue = true;
	if (window.fpValidateData) {
		lbContinue = window.fpValidateData();
	}
	if (lbContinue) {
		loForm.sModuleToLoad.value = '../calculators/calculators.asp';
		loForm.bSaveUserData.value = lbSave;
		submit_form(loForm);
	}
	return lbContinue;	
}

function launchToolbarMonteCarloCardGame() {
var lbContinue;
var loForm = document.frmMG;
var lbSave;

	lbSave = true;
	if(window.bDoNotSaveOnNavigateTo) {
		if(window.bDoNotSaveOnNavigateTo == true) {
			lbSave = false;
		}
	}
	lbContinue = true;
	if (window.fpValidateData) {
		lbContinue = window.fpValidateData();
	}
	if (lbContinue) {
		loForm.sModuleToLoad.value = '../montecarlocardgame/montecarlocardgame.asp';
		loForm.bSaveUserData.value = lbSave;
		submit_form(loForm);
	}
	return lbContinue;	
}

function launchToolbarLogout() {
var lbContinue;
var loForm = document.frmMG;
var lbSave;

	lbSave = true;
	if(window.bDoNotSaveOnNavigateTo) {
		if(window.bDoNotSaveOnNavigateTo == true) {
			lbSave = false;
		}
	}
	lbContinue = true;

	loForm.sModuleToLoad.value = '../login/logout.asp';
	loForm.bSaveUserData.value = lbSave;
	submit_form(loForm);

	return lbContinue;	
}

function launchToolbarMainMenu() {
var lbContinue;
var loForm = document.frmMG;
var lbSave;

	lbSave = true;
	if(window.bDoNotSaveOnNavigateTo) {
		if(window.bDoNotSaveOnNavigateTo == true) {
			lbSave = false;
		}
	}
	lbContinue = true;

	loForm.sModuleToLoad.value = '../mainmenu/mainmenu.asp';
	loForm.bSaveUserData.value = lbSave;
	submit_form(loForm);

	return lbContinue;	

}

function launchToolbarProfile() {
var lbContinue;
var loForm = document.frmMG;
var lbSave;

	lbSave = true;
	if(window.bDoNotSaveOnNavigateTo) {
		if(window.bDoNotSaveOnNavigateTo == true) {
			lbSave = false;
		}
	}
	lbContinue = true;
	if (window.fpValidateData) {
		lbContinue = window.fpValidateData();
	}
	if (lbContinue) {
		loForm.sModuleToLoad.value = '../profile/profile.asp';
		loForm.bSaveUserData.value = lbSave;
		submit_form(loForm);
	}
	return lbContinue;	
}

function launchToolbarUpdateAdvisor() {
var lbContinue;
var loForm = document.frmMG;
var lbSave;

	lbSave = true;
	if(window.bDoNotSaveOnNavigateTo) {
		if(window.bDoNotSaveOnNavigateTo == true) {
			lbSave = false;
		}
	}
	loForm.sModuleToLoad.value = '../advisorprofile/advisorprofile.asp';
	loForm.bSaveUserData.value = lbSave;
	submit_form(loForm);
}

function launchToolbarAdvisorMaintenance() {
var lbContinue;
var loForm = document.frmMG;
var lbSave;

	lbSave = true;
	if(window.bDoNotSaveOnNavigateTo) {
		if(window.bDoNotSaveOnNavigateTo == true) {
			lbSave = lbSave;
		}
	}
	loForm.sModuleToLoad.value = '../maintenance/maintenance.asp';
	loForm.bSaveUserData.value = true;
	submit_form(loForm);
}

function openMStarReport(psURL)
{
  windowHandle = window.open(psURL,'MorningstarReport','height=550,width=620,menubar=no,location=no,status=no,resizable=yes,scrollbars=yes');
	if (windowHandle.opener) {
    		windowHandle.focus();
	}
}

function launchPage(psURL, save) {
var lbContinue;
var loForm = document.frmMG;
var lbSave;

	lbSave = save != null ? save : true;

	if(window.bDoNotSaveOnNavigateTo) {
		if(window.bDoNotSaveOnNavigateTo == true) {
			lbSave = false;
		}
	}
	lbContinue = true;
	if (lbSave && window.fpValidateData) {
		lbContinue = window.fpValidateData();
	}

	if (lbContinue) {
		loForm.sAppToLoad.value = psURL;
		loForm.bStorePage.value = lbSave;
		submit_form(loForm);
	}
}
            
